module.exports = __webpack_public_path__ + "img/trash-red.62dbf8d5.svg";